import React from 'react'
import Header from '../Header/Header'

function Map() {
    return (
        <div>
              <Header label="KGP Map"/>
        </div>
    )
}

export default Map
